import { FeesBySolutionProvider } from 'sonata-platform-components';
import { BaseCurrencyInterface } from 'sonata-static-storage/lib/schemas/baseCurrency/baseCurrency.schema';
import { UserInterface } from 'sonata-static-storage/lib/schemas/user/user.schema';
import { UserRoleInterface } from 'sonata-static-storage/lib/schemas/user/userRole.schema';

import FeesBySolutionWizard from './FeesBySolutionWizard/FeesBySolutionWizard';

type Props = {
  campaign: Record<string, any>;
  currencyInfo: BaseCurrencyInterface;
  isLoading: boolean;
  isModalOpened: boolean;
  isSelectorDataLoading?: boolean;
  mode: 'create' | 'edit';
  onClose: () => void;
  onFinish: (campaign: Record<string, any>) => void;
  onSelectorSelectionChange?: (campaignPlanId?: string, insertionOrderId?: string) => void;
  options?: {
    inheritCreativeConfigFromIO: boolean;
    inheritMapConfigFromIO: boolean;
    numberOfEntitiesToCreate: number;
  };
  setOptions?: (optionsParam: {
    inheritCreativeConfigFromIO: boolean;
    inheritMapConfigFromIO: boolean;
    numberOfEntitiesToCreate: number;
  }) => void;
  showSelectorStep?: boolean;
  user: UserInterface;
  userRoles: UserRoleInterface[];
};

function LineItemWizard({
  campaign: initialCampaign,
  currencyInfo,
  isLoading,
  isModalOpened,
  isSelectorDataLoading,
  mode,
  onClose,
  onFinish,
  onSelectorSelectionChange,
  options,
  setOptions,
  showSelectorStep,
  user,
  userRoles
}: Props) {
  return (
    <FeesBySolutionProvider
      campaign={initialCampaign}
      currencyInfo={currencyInfo}
      mode={mode}
      options={options}
      setOptions={setOptions}
      user={user}
      userRoles={userRoles}
    >
      <FeesBySolutionWizard
        isLoading={isLoading}
        isModalOpened={isModalOpened}
        isSelectorDataLoading={isSelectorDataLoading}
        onClose={onClose}
        onFinish={onFinish}
        onSelectorSelectionChange={onSelectorSelectionChange}
        showSelectorStep={showSelectorStep}
      />
    </FeesBySolutionProvider>
  );
}

export default LineItemWizard;
